/**
 *  @class
 *  @function ModalDialog
 */


if (!customElements.get('modal-dialog')) {
  
  class ModalDialog extends HTMLElement {
    
    constructor() {
      
      super();

      this.id = this.getAttribute('id');
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.button = this.querySelector('[id^="ModalClose-"]');
      this.button.addEventListener('click', this.hide.bind(this));
    }

    // connectedCallback() {
    //   if (this.moved) return;
    //   this.moved = true;
    //   document.body.appendChild(this);
    // }

    show() {
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());

      if (this.popup) {

      }
    }

  }
  customElements.define('modal-dialog', ModalDialog);
}




if (!customElements.get('modal-opener')) {
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('#button-sm-open');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
    
  }
  customElements.define('modal-opener', ModalOpener);
}